<div class="grid">
    <div class="top-section">
        <h2>{{ "dtmMainPageLib.subpage.whereYouCanFly.media.title" | transloco }}</h2>
        <!--TODO:DTM-6016 will be provided later
        <p class="description">{{ "dtmMainPageLib.subpage.whereYouCanFly.media.description" | transloco }}</p
        >-->
    </div>
    <div class="movie">
        <h3>No Drone Zone - Zanim wystartujesz dronem, sprawdź gdzie możesz latać</h3>
        <iframe
            width="560"
            height="315"
            src="https://www.youtube.com/embed/VsysSxXsw7c?si=NJa6Xvv-0VZ6ty88"
            title="YouTube video player"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerpolicy="strict-origin-when-cross-origin"
            allowfullscreen
        ></iframe>
    </div>
    <div class="movie">
        <h3>Porozmawiajmy o dronach</h3>
        <iframe
            src="https://www.youtube.com/embed/UoTdojD0u-0?si=-4j-RmeelNoGysWq"
            title="YouTube video player"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerpolicy="strict-origin-when-cross-origin"
            allowfullscreen
        ></iframe>
    </div>
    <!--TODO:DTM-6016  will be provided later
    <h2 class="social-medial-title">{{ "dtmMainPageLib.subpage.whereYouCanFly.media.socialMediaTitle" | transloco }}</h2>
    <a href="#" class="social-media-link" target="_blank" rel="noopener noreferrer">
        <img ngSrc="/assets/images/where-you-can-fly/social-placeholder.png?onesize" width="263" height="358" alt="" />
    </a>
    <a href="#" class="social-media-link" target="_blank" rel="noopener noreferrer">
        <img ngSrc="/assets/images/where-you-can-fly/social-placeholder.png?onesize" width="263" height="358" alt="" />
    </a>
    <a href="#" class="social-media-link" target="_blank" rel="noopener noreferrer">
        <img ngSrc="/assets/images/where-you-can-fly/social-placeholder.png?onesize" width="263" height="358" alt="" />
    </a>
    <a href="#" class="social-media-link" target="_blank" rel="noopener noreferrer">
        <img ngSrc="/assets/images/where-you-can-fly/social-placeholder.png?onesize" width="263" height="358" alt="" />
    </a>
    -->
</div>
